// ErrorPage.js
import React from "react";
import { useNavigate } from "react-router-dom";

export default function ErrorPage() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "#f8d7da",
        color: "#721c24",
        fontFamily: "Arial, sans-serif",
        textAlign: "center",
        padding: "20px",
      }}
    >
      <h1>🚫 Access Denied</h1>
      <p>Your license has expired or you are not authorized to access this page.</p>
      <button
        style={{
          padding: "10px 20px",
          marginTop: "20px",
          backgroundColor: "#f5c6cb",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
          color: "#721c24",
          fontWeight: "bold",
        }}
        onClick={() => navigate("/")} // Redirect back to home
      >
        Go Back Home
      </button>
    </div>
  );
}
